import script from "./InvestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestForm.vue?vue&type=script&setup=true&lang=ts"

import "./InvestForm.vue?vue&type=style&index=0&id=6ef2bb0c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef2bb0c"]])

export default __exports__